import { useAppStore } from "./store";
import { useEffect, useState } from "react";

export function StoreProvider({ children, loadingComponent }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    useAppStore.persist
      .rehydrate()
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return loadingComponent;
  }

  return children;
}
